import React from "react";
import LicensePlateState from "../common/LicensePlateState";
import TextField from "@mui/material/TextField";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";

const US_OPTIONS = LicensePlateState.All.filter((lps) => lps.countryCode === "US" && lps.abbreviation !== "PR").map(
  (lps) => lps.abbreviation,
);
const OTHER_OPTIONS = LicensePlateState.All.filter((lps) => lps.countryCode !== "US" || lps.abbreviation === "PR").map(
  (lps) => lps.abbreviation,
);
const OPTIONS = [...US_OPTIONS, ...OTHER_OPTIONS];

export const StateDropdown: React.FC<StateDropdownProps> = ({
  label,
  error,
  helperText,
  required,
  name,
  placeholder,
  ...autocompleteProps
}: StateDropdownProps) => {
  return (
    <Autocomplete
      {...autocompleteProps}
      options={OPTIONS}
      getOptionLabel={(opt) => LicensePlateState.FromAbbreviation(opt).fullName}
      groupBy={(opt) => (LicensePlateState.FromAbbreviation(opt).countryCode === "US" && opt !== "PR" ? "US" : "other")}
      renderGroup={(params) => (
        <React.Fragment key={params.key}>
          {params.group === "other" && <Divider />}
          {params.children}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          error={error}
          helperText={helperText}
          label={label}
          placeholder={placeholder}
          required={required}
        />
      )}
    />
  );
};

export interface StateDropdownProps
  extends Omit<
    AutocompleteProps<LicensePlateState["abbreviation"], false, boolean | undefined, false>,
    "options" | "renderInput"
  > {
  name?: string;
  label?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  placeholder?: string;
}

export default StateDropdown;
